import { Link } from 'react-router-dom';
import { getDramaById } from '@/lib/content';
import { mainDramaId } from '@/mocks/dramas';

export default function DramaIntro() {
  const drama = getDramaById(mainDramaId);
  if (!drama) return null;

  const progress = Math.round((drama.updatedEpisodes / drama.totalEpisodes) * 100);

  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-[320px_1fr] gap-8 lg:gap-12 items-start">
          <div className="w-full max-w-[280px] mx-auto lg:mx-0 lg:max-w-none rounded-lg overflow-hidden border border-background-200 bg-background-200">
            <div className="aspect-[3/4] w-full">
              <img
                src={drama.cover}
                alt="迷人的保姆剧集封面"
                title="迷人的保姆 - 高清电视剧在线观看"
                className="w-full h-full object-top object-cover"
              />
            </div>
          </div>

          <div className="min-w-0">
            <span className="inline-flex items-center gap-1.5 text-xs font-label font-medium tracking-wide uppercase text-accent-600 mb-3">
              <span className="w-4 h-[2px] bg-accent-500 rounded-full"></span>
              本剧简介
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">{drama.title}</h2>
            <p className="mt-1.5 font-label text-sm text-foreground-500">{drama.alias}</p>

            <div className="mt-5 flex flex-wrap gap-2">
              {drama.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-1 rounded-full text-xs bg-secondary-100 text-secondary-900"
                >
                  {tag}
                </span>
              ))}
              {drama.genres.map((genre) => (
                <span
                  key={genre}
                  className="px-2.5 py-1 rounded-full text-xs bg-background-100 text-foreground-700 border border-background-200"
                >
                  {genre}
                </span>
              ))}
            </div>

            <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed">
              {drama.longSynopsis}
            </p>

            <dl className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 text-sm">
              <div className="flex gap-2">
                <dt className="text-foreground-500 shrink-0">导演</dt>
                <dd className="text-foreground-900">{drama.director}</dd>
              </div>
              <div className="flex gap-2">
                <dt className="text-foreground-500 shrink-0">上映年份</dt>
                <dd className="text-foreground-900 font-label">{drama.year}</dd>
              </div>
              <div className="flex gap-2">
                <dt className="text-foreground-500 shrink-0">主要演员</dt>
                <dd className="text-foreground-900 truncate">{drama.cast.join('、')}</dd>
              </div>
              <div className="flex gap-2">
                <dt className="text-foreground-500 shrink-0">更新安排</dt>
                <dd className="text-foreground-900">{drama.weekUpdate}</dd>
              </div>
            </dl>

            <div className="mt-7 max-w-md">
              <div className="flex items-center justify-between text-xs text-foreground-600 mb-2">
                <span>
                  更新进度 · 已更新 <strong className="text-primary-700 font-label">{drama.updatedEpisodes}</strong> / {drama.totalEpisodes} 集
                </span>
                <span className="font-label">{progress}%</span>
              </div>
              <div className="h-2 w-full rounded-full bg-background-200 overflow-hidden">
                <div
                  className="h-full rounded-full bg-accent-500 transition-all duration-700"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to={`/play/${mainDramaId}-18`}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-play-fill text-lg"></i>
                开始观看
              </Link>
              <Link
                to={`/detail/${drama.id}`}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                <i className="ri-list-check-2 text-lg"></i>
                全部剧集目录
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}